import { useCallback, useEffect, useState } from 'react';

/* -------------------------------------------------------------------------------------------------
 * Hook: useProjectDefaultView
 * -----------------------------------------------------------------------------------------------*/

enum ProjectViewTypeEnum {
    DEFAULT = 'DEFAULT',
    MAP = 'MAP',
}

const useProjectDefaultView = () => {
    const getDefaultView = useCallback(() => {
        return (localStorage.getItem('pc_project_view') as ProjectViewTypeEnum) || ProjectViewTypeEnum.DEFAULT;
    }, []);

    const setDefaultView = useCallback((value: string) => {
        return localStorage.setItem('pc_project_view', value);
    }, []);

    const [view, setView] = useState<ProjectViewTypeEnum>(getDefaultView());

    useEffect(() => {
        setDefaultView(view);
    }, [view, setDefaultView]);

    const toggleView = useCallback(() => {
        setView((prev) => {
            if (prev === ProjectViewTypeEnum.DEFAULT) return ProjectViewTypeEnum.MAP;

            return ProjectViewTypeEnum.DEFAULT;
        });
    }, []);

    return {
        isDefaultView: view === ProjectViewTypeEnum.DEFAULT,
        isMapView: view === ProjectViewTypeEnum.MAP,
        toggleView,
    };
};

export default useProjectDefaultView;
